var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7595 12.0317C14.2376 12.5098 14.2376 13.2843 13.7595 13.7624C13.5224 14.0014 13.2088 14.12 12.8951 14.12C12.5815 14.12 12.2687 14.0005 12.03 13.7614L7.99953 9.73307L3.96944 13.7605C3.7304 14.0014 3.41715 14.12 3.10391 14.12C2.79067 14.12 2.47781 14.0014 2.23857 13.7605C1.76048 13.2824 1.76048 12.5079 2.23857 12.0298L6.26981 7.99857L2.23857 3.96925C1.76048 3.49116 1.76048 2.71666 2.23857 2.23857C2.71666 1.76048 3.49116 1.76048 3.96925 2.23857L7.99953 6.27172L12.0308 2.24048C12.5088 1.7624 13.2834 1.7624 13.7614 2.24048C14.2395 2.71857 14.2395 3.49307 13.7614 3.97116L9.7302 8.00239L13.7595 12.0317Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.aaaa75d6e5c0d94d086c5d9537852c1d.svg";
export { ForwardRef as ReactComponent };